export const WORKSPACE_MEMBERS = ["WORKSPACE_MEMBERS"];
export const WORKSPACE_ANALYTICS = ["WORKSPACE_ANALYTICS"];
export const WORKSPACE = ["WORKSPACE"];

export enum PermissionLevel {
  SA = "support_agent",
  ADMIN = "admin",
  OWNER = "owner",
}

export interface RoleOption {
  value: PermissionLevel;
  label: string;
}
export type Member = {
  id: string;
  name: string;
  email: string;
  role: PermissionLevel;
  avatar: string | null;
};

export type UpdateUser = {
  name: string;
  email: string;
  avatar: number;
  old_password?: string;
  new_password1?: string;
  new_password2?: string;
};

export type UpdateWorkspace = {
  name: string;
  slug: string;
  avatar: number;
};
